import { ContentWidth, TextWidth } from '@ta-interaktiv/react-disco-grid'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import ArrowLeft from './icn_arrow_left.svg'
import ArrowRight from './icn_arrow_right.svg'

import { Flooding_DE, Flooding_FR } from '../Localization/Flooding'
const Places = [
  'Venedig',
  'NewYork',
  'Amsterdam',
  'Bangladesh',
  'London',
  'Lissabon',
]
const FloodLevels = [0, 1, 3, 10]
const Images: { [key: string]: { [key: number]: string } } = {}
Places.map((place) => {
  const levels: { [key: number]: string } = {}
  FloodLevels.map(
    (floodLevel) =>
      (levels[floodLevel] = require('./images/__' +
        place +
        '_' +
        floodLevel +
        '.jpeg'))
  )
  Images[place] = levels
})

export const Flooding = ({
  lang = 'de',
  colorMode = 'light',
}: {
  lang?: 'de' | 'fr'
  colorMode?: 'light' | 'dark' | undefined
}) => {
  const [floodLevel, setFloodLevel] = useState(1)
  const [place, setPlace] = useState(Places[0])
  const [placeNumber, setPlaceNumber] = useState(0)
  const Locales = lang === 'de' ? Flooding_DE : Flooding_FR

  const switchPlace = (direction: 'up' | 'down') => {
    if (direction === 'up') {
      if (placeNumber < Places.length - 1) {
        setPlace(Places[placeNumber + 1])
        setPlaceNumber(placeNumber + 1)
      }
    }
    if (direction === 'down') {
      if (placeNumber > 0) {
        setPlace(Places[placeNumber - 1])
        setPlaceNumber(placeNumber - 1)
      }
    }
  }
  return (
    <>
      {' '}
      <TextWidth>
        <div className='title'>{Locales.labels.title}</div>
      </TextWidth>
      <StyledFlooding>
        <TextWidth>
          <MenuHolder desktopColCount={4} mobileColCount={2}>
            <MenuHint> {Locales.labels.floodHint}:</MenuHint>
            {FloodLevels.map((_floodlevel) => {
              return (
                <FloodButton
                  onClick={() => setFloodLevel(_floodlevel)}
                  disabled={_floodlevel === floodLevel}
                  colorMode={colorMode}
                >
                  {!_floodlevel ? _floodlevel : _floodlevel + 'm'}
                </FloodButton>
              )
            })}
            <PlaceNavigation>
              <PlaceNumberSwitch
                onClick={() => switchPlace('down')}
                disabled={placeNumber === 0}
                colorMode={colorMode}
              >
                <img src={ArrowLeft} />
              </PlaceNumberSwitch>
              <PlaceNumberlabel>
                {Locales.places[Places[placeNumber]].label}
              </PlaceNumberlabel>
              <PlaceNumberSwitch
                onClick={() => switchPlace('up')}
                disabled={placeNumber === Places.length - 1}
                colorMode={colorMode}
              >
                <img src={ArrowRight} />
              </PlaceNumberSwitch>
            </PlaceNavigation>
          </MenuHolder>
        </TextWidth>
        <ContentWidth>
          <ImageHolder
            style={{
              backgroundImage: 'url(' + Images[place][0] + ')',
            }}
          >
            {[1, 3, 10].map((level) => {
              return (
                <OverlayImage
                  style={{
                    opacity: floodLevel === level ? 1 : 0,
                    backgroundImage: 'url(' + Images[place][level] + ')',
                  }}
                />
              )
            })}

            <FloodLevelDisplay>
              <PlaceTitle className='titl'>
                {Locales.places[place].label}
              </PlaceTitle>
              <FloodLevel>
                {Locales.labels.floodLevelRise}: {floodLevel}m
              </FloodLevel>
            </FloodLevelDisplay>
          </ImageHolder>
        </ContentWidth>
        <TextWidth>
          <PlaceSource>{Locales.labels.source}</PlaceSource>
        </TextWidth>
      </StyledFlooding>
    </>
  )
}
const OverlayImage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-position: 50% 50%;
  opacity: 0.5;
`

const PlaceNumberSwitch = styled.button<{
  colorMode: 'light' | 'dark' | undefined
}>`
  width: 50px;
  border: 0;
  background-color: ${({ colorMode }) =>
    colorMode === 'dark'
      ? 'var(--brandblue-bright-1)'
      : 'var(--brandblue-main)'};
  flex: 0 0 50px;
  cursor: pointer;
  &:disabled {
    opacity: 0.2;
  }
`
const PlaceNumberlabel = styled.div`
  text-align: center;
  font-size: 22px;
  flex: 0 0 calc(100% - 130px);
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 15px;
  margin-right: 15px;
`
const PlaceNavigation = styled.div`
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid var(--brandblue-bright-4);
  grid-column: 1/-1;
  font-size: 15px;
  display: flex;
  align-items: center;
`
const MenuHint = styled.div`
  grid-column: 1/-1;
  font-size: 15px;
`
const FloodButton = styled.button<{ colorMode: 'light' | 'dark' | undefined }>`
  border: 0;
  padding: 15px 15px;
  background-color: ${({ colorMode }) =>
    colorMode === 'dark'
      ? 'var(--brandblue-bright-1)'
      : 'var(--brandblue-main)'};
  color: #fff;
  font-size: 18px;
  letter-spacing: 1px;
  font-weight: 200;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
  &:disabled {
    opacity: 0.2;
  }
`
const StyledFlooding = styled.div`
  overflow: hidden;
`

const PlaceSource = styled.div`
  font-size: 12px;
  color: var(--gray-3);
  line-height: 1.4em;
  margin-top: 15px;
`
const PlaceTitle = styled.div`
  font-weight: 700;
  font-size: 22px;
`
const FloodLevel = styled.div`
  font-size: 18px;
  letter-spacing: 0.4px;
`

const MenuHolder = styled.div<{
  desktopColCount: number
  mobileColCount: number
}>`
  display: grid;
  gap: 10px;
  grid-template-columns: ${({ desktopColCount }) =>
    `repeat(${desktopColCount}, 1fr);`};
  width: 100%;
  margin-bottom: 30px;
  max-width: 100vw;

  @media only screen and (max-width: 711px) {
    grid-template-columns: ${({ mobileColCount }) =>
      `repeat(${mobileColCount}, 1fr);`};
  }
`
const ImageHolder = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 50%;
  background-size: cover;
  @media only screen and (max-width: 711px) {
    padding-bottom: 100%;
  }
  background-position: 50% 50%;
`

const FloodLevelDisplay = styled.div`
  position: absolute;
  left: 20px;
  top: 20px;
  color: #fff;
`
